// import projImg1 from '../assets/img/netflix.png';
import projImg2 from '../assets/img/Electroz.png';
import projImg3 from '../assets/img/Portfolio.png';
// import projImg4 from '../assets/img/TODO.png';
// import projImg5 from '../assets/img/Tesla.png';
import projImg6 from '../assets/img/ARS-info.png';
// import projImg7 from '../assets/img/Inventory Management System.png';
// import projImg8 from '../assets/img/User Management.png';
import projImg9 from '../assets/img/Black Link.png';
import projImg10 from '../assets/img/AquaSwims.png';
import projImg11 from '../assets/img/3D app.png';
import projImg12 from '../assets/img/TESSUTO.png';
import projImg13 from '../assets/img/Project13.png';
import projImg14 from '../assets/img/Project14.png';
import projImg15 from '../assets/img/project 15.png';


  const projects = [
    {
      title: 'TESSUTO',
      description: 'Design & Development in Next js',
      imgUrl: projImg12,
      liveUrl: 'https://tessuto-userside.vercel.app/',
      GitUrl: 'https://github.com/AnandhuRs619/Tessuto_userside',
    },

    {
      title: 'Sarvamsafety',
      description: 'Design & Development in Next js',
      imgUrl: projImg13,
      liveUrl: 'https://www.sarvamsafety.com/',
      GitUrl: '#projects',
     
    },
    {
      title: 'LIFTERS CLUB',
      description: 'Design & Development in React js',
      imgUrl:projImg14,
      liveUrl: 'https://liftersclub.ca',
      GitUrl: '#projects',

    },
    {
      title: 'Aquaswims',
      description: 'Design & Development in Next js',
      imgUrl: projImg10,
      liveUrl: 'https://aquaswims.com/',
      GitUrl: 'https://github.com/AnandhuRs619/aquaswims',
    },
    {
      title: 'Ologytechschool',
      description: 'Design & Development in Next js',
      imgUrl: projImg15,
      liveUrl: 'https://www.ologytechschool.com/',
      GitUrl: '#projects',
    },
    {
      title: 'Black Link - socialMedia-app',
      description: 'Design & Development in MERN Stack',
      imgUrl: projImg9,
      liveUrl: '#projects',
      GitUrl: 'https://github.com/AnandhuRs619/socialMedia-app',
    },
    {
      title: '3D Modal App',
      description: 'Design & Development in MERN Stack',
      imgUrl: projImg11,
      liveUrl: 'https://3-dmodels-viewer-app.vercel.app/',
      GitUrl: 'https://github.com/AnandhuRs619/3Dmodels-viewer-app',
    },
    {
      title: 'Electroz.Shop',
      description: 'Ecommerce Website using MERN Stack',
      imgUrl: projImg2,
      liveUrl: 'https://www.electroz.shop/',
      GitUrl: 'https://github.com/AnandhuRs619/Electroz',
    },
    // {
    //   title: 'Automotive-Project',
    //   description: 'Design & Development in MERN Stack',
    //   imgUrl: projImg7,
    //   liveUrl: '#projects',
    //   GitUrl: 'https://github.com/AnandhuRs619/Automotive-Project',
    // },
    // {
    //   title: 'NETFLIX-Clone',
    //   description: 'Design & Development in React',
    //   imgUrl: projImg1,
    //   liveUrl: 'https://mynetflix-app-clone.netlify.app/',
    //   GitUrl: 'https://github.com/AnandhuRs619/netfilx-clone',
    // },
    // {
    //   title: 'User_Management_System',
    //   description: 'Design & Development in MERN Stack',
    //   imgUrl: projImg8,
    //   liveUrl: '#projects',
    //   GitUrl: 'https://github.com/AnandhuRs619/React_User_Management',
    // },
    {
      title: 'MY Portfolio',
      description: 'Design & Development',
      imgUrl: projImg3,
      liveUrl: 'https://anandhursprofile.netlify.app/',
      GitUrl: 'https://github.com/AnandhuRs619/Personal-Website',
    },
    // {
    //   title: 'Todo-APP',
    //   description: 'Design & Development in React',
    //   imgUrl: projImg4,
    //   liveUrl: 'https://mytodo-appz.netlify.app/',
    //   GitUrl: 'https://github.com/AnandhuRs619/React-Todo-App',
    // },
    // {
    //   title: 'Tesla-clone',
    //   description: 'Design & Development',
    //   imgUrl: projImg5,
    //   liveUrl: 'https://tesla-clone-0.netlify.app/',
    //   GitUrl: 'https://github.com/AnandhuRs619/tesla',
    // },
    {
      title: 'ARS-INFOS',
      description: 'Design & Development',
      imgUrl: projImg6,
      liveUrl: 'https://ars-info.netlify.app/',
      GitUrl: 'https://github.com/AnandhuRs619/ARS-infos',
    },
  ];


  export default projects;